@import 'styles/mixins';
@import 'styles/variables';

.container {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.text {
  @include md-regular;
  color: $grey-40;
}

.folderButton {
  color: $grey-50;

  & svg {
    fill: $blue-40;
  }

  .folderButtonText {
    @include line-clamp;

    max-width: 175px;

    @include for-tablet-landscape-up {
      max-width: 465px;
    }
  }
}

.tooltip {
  @include sm-medium;
}

.alternateButton {
  svg {
    fill: none !important;

    path {
      stroke: var(--action-60);
    }
  }
}
